import { Message } from "@/components/shared/message";
import { PDFViewer } from "@/components/shared/pdf-viewer";
import { Portal } from "@/components/shared/portal";
import { Button, Skeleton, View } from "@/components/ui";
import { handleOpenLink } from "@/lib/platform";
import { useGenerateInvoiceAccountStatementPdfStore } from "@/store/invoices/generateInvoiceAccountStatementPdf";
import { useEffect, useMemo } from "react";

export function InvoiceAccountStatementPdf({ token }: { token: string }) {
  const useStore = useGenerateInvoiceAccountStatementPdfStore;

  const { data: pdfUrl, fetch, loading, error } = useStore();

  useEffect(() => {
    if (token) {
      fetch({
        requestPayload: {
          input: {
            token,
          },
        },
      });
    }
  }, [token]);

  const handleDownload = () => {
    if (pdfUrl) {
      handleOpenLink(pdfUrl);
    }
  };

  const renderButton = useMemo(() => {
    return (
      <Button
        variant="primary"
        color="CTA"
        className="min-w-[100px]"
        rounded="full"
        onClick={handleDownload}
        children="Download PDFs"
        disabled={loading}
      />
    );
  }, [handleDownload, loading]);

  if (loading) {
    return <Skeleton className="h-[500px] w-full" />;
  }

  if (error) {
    return <Message variant="danger" message={error} />;
  }

  return (
    <View>
      {pdfUrl ? (
        <PDFViewer url={pdfUrl} />
      ) : (
        <Message variant="danger" message="No Invoice Url" />
      )}
      <Portal name="BottomActions">{renderButton}</Portal>
    </View>
  );
}
